import React from "react";
import MainItemsList from "features/itemLists/MainListView/MainItemsList";

export default function PlanItemsContainer(props) {
  return (
    <MainItemsList
      listType="Plan"
      mainItems={props.planItems}
      dateHelper={props.dateHelper}
      dueItems={props.dueItems}
      fetchPlan={props.fetchPlan}
      currentTimeInMinutes={props.currentTimeInMinutes}
      newTask={props.newTask}
      setNewTask={props.setNewTask}
      setCursorIndex={props.setCursorIndex}
      removeEmptyDay={props.removeEmptyDay}
      setOpenChecklist={props.setOpenChecklist}
      
      //native
      onScroll={props.onScroll}
      listRef={props.listRef}
      scrollGutterHeight={props.scrollGutterHeight}
      animatedIndexHelper={props.animatedIndexHelper}
    />
  );
}
